<template>
  <section class="content">
  <div class="box box-info">
    <!-- <div class="p-grid"> -->
      <div class="p-toolbar p-component mb-4">
        <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openCounterDialog"
                icon="pi pi-plus" label="NEW"/>
          </div>
          </div>
        
      </div>
    <!-- </div> -->
  
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-col-12">
    <DataTable
      :value="countersList"
      :paginator="true"
      :rows="100"
      :first="0" :filters="filters"
      class="p-datatable-responsive-demo p-datatable-gridlines"
    >
      <Column header="S.N">
        <template #body="sl">
          {{sl.index+1}}
        </template>
      </Column>
      <Column field="name" :sortable="true" header="Name" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['name']"/>
        </template>
      </Column>

      <Column field="billPreFix" header="Bill Prefix" :sortable="true" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['billPreFix']"/>
        </template>
      </Column>

      <Column field="startBillNo" header="Start Bill No" :sortable="true" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['startBillNo']"/>
        </template>
      </Column>
      <!-- <Column field="isCounterActive" header="Active Counter" :sortable="true" filterMatchMode="contains" >
      <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['isCounterActive']" />
      </template>
      </Column> -->

      <Column header="Cash Account" field="cashAccountName" filterMatchMode="contains" :sortable="true">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['cashAccountName']"/>
        </template>
      </Column>

      <Column header="Esewa Account" field="esewaAccountName" filterMatchMode="contains" :sortable="true">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['esewaAccountName']"/>
        </template>
      </Column>

       <Column header="Khalti Account" field="khaltiAccountName" filterMatchMode="contains" :sortable="true">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['khaltiAccountName']"/>
        </template>
      </Column>
       <Column header="Bank Account" field="bankAccountName" filterMatchMode="contains" :sortable="true">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['bankAccountName']"/>
        </template>
      </Column>
       <Column header="Fonepay" field="fonePayAccountName" filterMatchMode="contains" :sortable="true">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['fonePayAccountName']"/>
        </template>
      </Column>
      <Column header="Nmc" field="darazAccountName" filterMatchMode="contains" :sortable="true">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['darazAccountName']"/>
        </template>
      </Column>

      <Column header="Action" >
        <template #empty>No record found</template>
        <template #body="slotProps">
          <Button type="button" icon="pi pi-pencil" class="p-button-success p-button-sm"
                  @click="editCounter(slotProps.data)"/>
          <Button icon="pi pi-trash" class="p-button-danger p-button-sm"
                  @click="openDeleteDialog(slotProps.data.id)"/>
        </template>
      </Column>
    </DataTable>
    </div>
    <Dialog header="Counter Setup" :visible.sync="showCounterDialog"
            :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
      <Divider/>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label for="name">Name<span style="color:red">*</span></label>
          <InputText type="text" ref="name" v-model.trim="counterName"/>
        </div>
        <div class="p-field p-col-12 p-md-6 p-sm-3">
          <label for="name">Bill Prefix</label>
          <InputText v-model="billPreFix"/>
        </div>
        <div class="p-field p-col-12 p-md-6 p-sm-3">
          <label for="name">Start Bill no</label>
          <InputNumber v-model="startBillNo"/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="master">Is Master</label>
          <div class="p-field p-col-12 p-md-6">
            <Checkbox id="master" v-model="counterStatus" :binary="true"/>
          </div>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="head">Cash Account</label>
          <Dropdown
            v-model="cashAccountId"
            :options="cashBankLists"
            optionLabel="name" :filter="true"
            placeholder="Select Cash Account"
            :showClear="true"
          />
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="head">eSewa Account</label>
          <Dropdown
            v-model="eSewaAccountId"
            :options="cashBankLists"
            optionLabel="name" :filter="true"
            placeholder="Select eSewa Account"
            :showClear="true"
          />
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="head">Khalti Account</label>
          <Dropdown
            v-model="khaltiAccountId"
            :options="cashBankLists"
            optionLabel="name" :filter="true"
            placeholder="Select Khalti Account"
            :showClear="true"
          />
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="head">Bank Account</label>
          <Dropdown
            v-model="bankAccountId"
            :options="cashBankLists"
            optionLabel="name" :filter="true"
            placeholder="Select bank Account"
            :showClear="true"
          />
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="head">Fonepay</label>
          <Dropdown
            v-model="fonePayAccountId"
            :options="cashBankLists"
            optionLabel="name" :filter="true"
            placeholder="Select fonePay Account"
            :showClear="true"
          />
        </div>

        <div class="p-field p-col-12 p-md-6">
          <label for="head">Nmc</label>
          <Dropdown
            v-model="darazAccountId"
            :options="cashBankLists"
            optionLabel="name" :filter="true"
            placeholder="Select daraz Account"
            :showClear="true"
          />
        </div>

      </div>
      <template #footer>
        <Button class="p-button-raised p-button-rounded" :label="editing?'Update':'Add'" @click.prevent="addCounter"/>
        <Button class="p-button-raised p-button-info" v-if="!editing" label="Add & New"
                @click.prevent="saveAndNewCounter"/>
        <Button class="p-button-raised p-button-danger" label="Cancel" @click.prevent="cancel"/>
      </template>
    </Dialog>
       </div>
    <DeleteDialog v-model="showDeleteDialog" @cancel="closeDeleteDialog" @deleted="deleteCounter"/>
  </div>
</section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Dropdown from 'primevue/dropdown'
import Column from 'primevue/column'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Checkbox from 'primevue/checkbox'
import InputNumber from 'primevue/inputnumber'
import Dialog from 'primevue/dialog'
import DeleteDialog from '../../../layout/dialog'
import Divider from 'primevue/divider'

export default {
  name: 'CounterSetup',
  data() {
    return {
      showCounterDialog: false,
      startBillNo: 0,
      billPreFix: '',
      counterName: '',
      editing: false,
      showDeleteDialog: false,
      counterStatus: false,
      filters: {},
      counterId: null,
      cashAccountId: null,
      eSewaAccountId: null,
      khaltiAccountId: null,
      bankAccountId: null,
      fonePayAccountId: null,
      darazAccountId: null,
      cashAccId: 0,
      eSewaAccId: 0,
      khaltiAccId: 0,
      bankAccId: 0,
      fonePayAccId: 0,
      darazAcctId: 0
    }
  },
  mounted() {
    this.listOfCounter()
    this.cashBankList()
  },
  computed: {
    countersList() {
      return this.$store.state.pos.countersList
    },
    cashBankLists() {
      return this.$store.state.accountMaster.cashBankLists
    }
  },
  methods: {
    async addCounter() {
      if (this.billPreFix === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Bill Prefix cannot be empty!', life: 3000})
        return
      }
      if (this.startBillNo === 0) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Start Bill No cannot be empty!', life: 3000})
        return
      }
      if (this.cashAccountId !== null) {
        this.cashAccId = this.cashAccountId.id
      }
      if (this.eSewaAccountId !== null) {
        this.esewaAccId = this.eSewaAccountId.id
      }
      if (this.khaltiAccountId !== null) {
        this.khaltiAccId = this.khaltiAccountId.id
      }
      if (this.bankAccountId !== null) {
        this.bankAccId = this.bankAccountId.id
      }
      if (this.fonePayAccountId !== null) {
        this.fonePayAccId = this.fonePayAccountId.id
      }
      if (this.darazAccountId !== null) {
        this.darazAcctId = this.darazAccountId.id
      }
      // // debugger
      let counter = {
        id: this.counterId,
        name: this.counterName,
        isCounterActive: this.counterStatus,
        startBillNo: this.startBillNo,
        billPreFix: this.billPreFix,
        cashAccountId: this.cashAccId,
        esewaAccountId: this.esewaAccId,
        khaltiAccountId: this.khaltiAccId,
        bankAccountId: this.bankAccId,
        fonePayAccountId: this.fonePayAccId,
        daraAccountId: this.darazAcctId
      }
      let response = ''
      if (!this.editing) {
        response = await this.$store.dispatch('saveCounter', counter)
      } else {
        response = await this.$store.dispatch('updateCounter', counter)
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        this.cancel()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!', life: 3000})
      }
    },
    async cashBankList() {
      await this.$store.dispatch('loadCashAndBankList')
    },
    async saveAndNewCounter() {
      if (this.billPreFix === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Bill Prefix cannot be empty!', life: 3000})
        return
      }
      if (this.startBillNo === 0) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Start Bill No cannot be empty!', life: 3000})
        return
      }
      let counter = {
        name: this.counterName,
        isCounterActive: this.counterStatus,
        startBillNo: this.startBillNo,
        billPreFix: this.billPreFix,
        cashAccountId: this.cashAccountId.id,
        esewaAccountId: this.eSewaAccountId.id,
        khaltiAccountId: this.khaltiAccountId.id,
        bankAccountId: this.bankAccountId.id,
        fonePayAccountId: this.fonePayAccountId.id
      }
      let response = await this.$store.dispatch('saveCounter', counter)
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        this.cancel()
        this.showCounterDialog = true
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!', life: 3000})
      }
    },
    editCounter(data) {
      this.editing = true
      this.counterId = data.id
      this.billPreFix = data.billPreFix
      this.counterName = data.name
      this.counterStatus = data.isCounterActive
      this.startBillNo = data.startBillNo
      if (data.cashAccId === undefined) {
        this.cashAccountId = ''
      } else {
        this.cashAccountId = data.cashAccId
      }
      if (data.esewaAccId === undefined) {
        this.eSewaAccountId = ''
      } else {
        this.eSewaAccountId = data.esewaAccId
      }
      if (data.khaltiAccId === undefined) {
        this.khaltiAccountId = ''
      } else {
        this.khaltiAccountId = data.khaltiAccId
      }
      if (data.bankAccId === undefined) {
        this.bankAccountId = ''
      } else {
        this.bankAccountId = data.bankAccId
      }
      if (data.fonePayAccId === undefined) {
        this.fonePayAccountId = ''
      } else {
        this.fonePayAccountId = data.fonePayAccId
      }
      if (data.darazPayAccId === undefined) {
        this.darazAccountId = ''
      } else {
        this.darazAccountId = data.darazPayAccId
      }
      this.openCounterDialog()
    },
    async listOfCounter() {
      await this.$store.dispatch('loadCountersList')
    },
    openCounterDialog() {
      this.showCounterDialog = true
    },
    openDeleteDialog(id) {
      this.showDeleteDialog = true
      this.counterId = id
    },
    async deleteCounter(value) {
      this.showDeleteDialog = true
      if (value.trim() === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Delete reason cannot be empty!', life: 3000})
        return
      }
      let deleteRe = {
        id: this.counterId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteCounter', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 3000})
      } else {
        this.$toast.add({severity: 'danger', summary: '', detail: resp.data.message, life: 3000})
      }
      this.closeDeleteDialog()
    },
    closeDeleteDialog(data) {
      this.showDeleteDialog = false
    },
    cancel() {
      this.editing = false
      this.startBillNo = 0
      this.billPreFix = ''
      this.counterName = ''
      this.showCounterDialog = false
      this.counterStatus = false
      this.cashAccountId = null
      this.eSewaAccountId = null
    }
  },
  components: {
    DataTable,
    Column,
    Button,
    InputText,
    Checkbox,
    Dialog,
    InputNumber,
    DeleteDialog,
    Dropdown,
    Divider
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// counterSetup.vue?e0b27fde